import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './js/Components/App';
import * as serviceWorker from './js/serviceWorker';
import { Provider } from 'react-redux';
import store from './js/Redux/store.js'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
